<template>
	<Popup
		v-model="selfDisplay"
		title="查看"
		:confirmBtnDisplay="false"
	>
		<div style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>上传图片</span>
				<div class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="img" alt="" style="">
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>序号</span>
				<el-input :value="order" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>名称</span>
				<el-input :value="name" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">链接</span>
				<el-input :value="link" disabled></el-input>
			</div>
		</div>
	</Popup>
</template>

<script>
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				img: '',
				order: '',
				name: '',
				link: ''
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.img = this.obj.img;
					this.order = this.obj.order;
					this.name = this.obj.name;
					this.link = this.obj.link;
				}
			}
		}
	}
</script>

<style>
</style>
